module.exports = __webpack_public_path__ + "static/media/ni.7b131ab3.svg";